import { z } from 'zod';

export enum CharacterGroup {
  Animals = 'animals',
  ApolloCharacters = 'apollo-characters',
}

export const CharacterPartsSchema = z.object({
  animatedImage: z.string(),
  pawImage: z.string(),
  headImage: z.string(),
});

export const CharacterSchema = z
  .object({
    animalType: z.string().optional(),
    characterType: z.string().optional(),
    characterGroup: z.nativeEnum(CharacterGroup).optional(),
    name: z.string(),
    voiceId: z.string(),
    volume: z.number(),
  })
  .extend(CharacterPartsSchema.shape)
  .transform((data) => ({
    ...data,
    characterType: data.characterType || data.animalType,
    characterGroup: data.characterGroup || CharacterGroup.Animals,
  }));

export type Character = z.infer<typeof CharacterSchema>;

export type CharacterParts = z.infer<typeof CharacterPartsSchema>;

export type CharacterPartKey = keyof CharacterParts;

export enum CharacterImageExtension {
  Gif = 'gif',
  Png = 'png',
}

export enum CharacterErrorType {
  CharacterNotFound = 'character_not_found',
  NotLoaded = 'not_loaded',
}
